import { render, staticRenderFns } from "./IconSelectSection.vue?vue&type=template&id=03d6a2ba&scoped=true&lang=html&"
import script from "./IconSelectSection.vue?vue&type=script&lang=ts&"
export * from "./IconSelectSection.vue?vue&type=script&lang=ts&"
import style0 from "./IconSelectSection.vue?vue&type=style&index=0&id=03d6a2ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d6a2ba",
  null
  
)

export default component.exports